
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useVendorStore from "../../HomePage/useVendorStore";
import { STATUS_BEGIN, STATUS_DONE, STATUS_FAIL } from "utils/constants/others";
import WhiltelistedFileTypes from "../../Common/Logout";

export default function useDDPodFormV2Logic() {
    const getPurchaseOrders = useVendorStore((state) => state.getPurchaseOrders);
    const getPurchaseOrderStatus = useVendorStore(
        (state) => state.getPurchaseOrderStatus
    );
    const validatePodOtp = useVendorStore((state) => state.validatePodOtp);
    const validatePodOtpStatus = useVendorStore(
        (state) => state.validatePodOtpStatus
    );
    const purchaseOrders = useVendorStore((state) => state.purchaseOrders);
    const getPresignedUrl = useVendorStore((state) => state.getPresignedUrl);
    const getPresignedUrlStatus = useVendorStore(
        (state) => state.getPresignedUrlStatus
    );
    const podPresignedUrl = useVendorStore((state) => state.podPresignedUrl);
    const podFilePath = useVendorStore((state) => state.podFilePath);
    const validatePodImage = useVendorStore((state) => state.validatePodImage);
    const validatePodImageResp = useVendorStore((state) => state.validatePodImageResp);
    const getSellerOrderDetails = useVendorStore((state) => state.getSellerOrderDetails);
    const sellerOrderDetailsStatus = useVendorStore((state) => state.sellerOrderDetailsStatus);
    const sellerOrderDetails = useVendorStore((state) => state.sellerOrderDetails);
    const validatePodImageStatus = useVendorStore((state) => state.validatePodImageStatus);
    const getBuyerOrderPodDetails = useVendorStore((state) => state.getBuyerOrderPodDetails);
    const buyerOrdersLinkedtoPO = useVendorStore((state) => state.buyerOrdersLinkedtoPO);

    const [po, setPo] = useState("");
    const [items, setItems] = useState("");
    let { source, purchaseOrderId, orderId } = useParams();
    const [showLoader, setShowLoader] = useState(false);
    const [tonnage, setTonnage] = useState(0);
    const [errorMsg, setErrorMsg] = useState(false);
    const [otpPage, setOtpPage] = useState(false);
    const [otp, setOtp] = useState("");
    const [showError, setShowError] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const navigate = useNavigate();
    const [podPages, setPodPages] = useState([]);
    const [imageArray, setImageArray] = useState(new Array(5).fill(null));
    const [previewImage, setPreviewImage] = useState([]);
    const [numberOfPodPages, setNumberOfPodPages] = useState(0);
    const [showPopUp, setShowPopUp] = useState(false);
    const [podPopUp, setPodPopUp] = useState(null);
    const [currentPageNumber, setCurrentPageNumber] = useState(0);
    const [doneMsg, setDoneMsg] = useState(false);
    const [fileTypeErr, setFileTypeErr] = useState(false);
    const [bo, setBo] = useState("");
    const [errorText, setErrorText] = useState("");

    useEffect(() => {
        getPurchaseOrders({
            is_item_required: true,
            purchase_order_id: purchaseOrderId,
        }, true);
        getSellerOrderDetails(orderId);
    }, []);

    useEffect(() => {
        if (getPurchaseOrderStatus === STATUS_DONE && purchaseOrders) {
            setPo(purchaseOrders[0]);
        }
        getBuyerOrderPodDetails({
            purchase_order_id: purchaseOrderId,
        });
        for (let i = 0; i < buyerOrdersLinkedtoPO.length; i++) {
            if (buyerOrdersLinkedtoPO[i].pod_order_id === parseInt(orderId)) {
                setBo(buyerOrdersLinkedtoPO[i]);
            }
        }
    }, [purchaseOrders]);

    useEffect(() => {
        if (getPurchaseOrderStatus === STATUS_BEGIN) {
            setShowLoader(true);
        }
        if (getPurchaseOrderStatus === STATUS_DONE) {
            setShowLoader(false);
        }
    }, [getPurchaseOrderStatus]);

    useEffect(() => {
        if (po.purchase_order_items) {
            setItems(po.purchase_order_items);
        }
        if (bo.number_of_pod_pages === 0) {
            setOtpPage(true);
        } else if (bo.number_of_pod_pages) {
            setNumberOfPodPages(bo.number_of_pod_pages);
        }
    }, [po]);

    useEffect(() => {
        setImageArray(new Array(numberOfPodPages).fill(null));
    }, [numberOfPodPages]);

    useEffect(() => {
        calculateTonnage();
    }, [items]);

    useEffect(() => {
        if (sellerOrderDetailsStatus == STATUS_DONE) {
            if (sellerOrderDetails.pod_images) {
                let imgArray = new Array(bo.number_of_pod_pages).fill(null);
                sellerOrderDetails.pod_images.map((img) => {
                    if (img.page_number !== 0) {
                        imgArray[img.page_number - 1] = {
                            page_no: img.page_number,
                            img_url: img.image_url,
                        };
                    }
                    return undefined;
                });
                setPreviewImage(imgArray);
            }
        }
        setShowLoader(false);
    }, [sellerOrderDetails]);

    useEffect(() => {
        if (validatePodImageStatus == STATUS_DONE) {
            if (!validatePodImageResp.is_image_valid) {
                setPodPopUp(validatePodImageResp.popup);
            } else {
                getSellerOrderDetails(orderId);
            }
        }
    }, [validatePodImageStatus]);

    useEffect(() => {
        if (podPopUp) {
            setShowPopUp(true);
        }
        setShowLoader(false);
    }, [podPopUp]);

    useEffect(() => {
        if (sellerOrderDetails.all_pages_uploaded) {
            setDoneMsg(true);
        }
    }, [sellerOrderDetails]);

    const calculateTonnage = () => {
        let total = 0;
        for (const item of items) {
            total = total + item.quantity_ordered * item.weight_per_packet;
        }
        setTonnage(total);
    };

    const navigateToOtpPage = () => {
        if (!sellerOrderDetails.all_pages_uploaded || errorMsg) {
            setErrorMsg(true);
        } else {
            setOtpPage(true);
        }
    };

    const makeValidateOtp = () => {
        validatePodOtp({
            order_id: parseInt(orderId),
            otp: otp,
            validate_all_pod_pages_uploaded: true,
            purchase_order_id: parseInt(purchaseOrderId),
        });
    };

    const closeConfirmation = () => {
        setOpenConfirmation(false);
        navigate("/ddPo/all");
        window.location.reload();
    };

    const imageValidationPopUpCloseHandler = () => {
        setShowPopUp(false);
    };

    const uploadFileToS3 = (file, preSignedUrl) => {
        return fetch(preSignedUrl, {
            method: "PUT",
            body: file,
            headers: {
                "Content-Type": file?.type,
            },
        })
            .then((response) => {
                if (response.ok) {
                    return response;
                } else {
                    setErrorMsg(true);
                }
            })
            .catch((err) => {
                setErrorMsg(true);
            });
    };

    useEffect(() => {
        if (validatePodOtpStatus?.status === STATUS_DONE) {
            setOpenConfirmation(true);
        } else if (validatePodOtpStatus?.status === STATUS_FAIL) {
            setShowError(true);
            setErrorText(validatePodOtpStatus?.message || "Wrong OTP Entered");
        }
    }, [validatePodOtpStatus]);

    useEffect(() => {
        if (podPages?.length > 0 && orderId > 0) {
            getPresignedUrl({
                order_id: parseInt(orderId),
            });
        }
    }, [podPages]);

    useEffect(() => {
        if (getPresignedUrlStatus === STATUS_DONE && podPages?.length > 0) {
            uploadFileToS3(podPages[podPages?.length - 1], podPresignedUrl).then((data) => {
                validatePodImage({
                    order_id: parseInt(orderId),
                    image_url: podPresignedUrl,
                    file_path: podFilePath,
                    page_number: currentPageNumber,
                });
            });
        }
    }, [getPresignedUrlStatus]);

    useEffect(() => {
        if (validatePodImageStatus === STATUS_FAIL) {
            setErrorMsg(true);
            setShowLoader(false);
        }
    }, [validatePodImageStatus]);

    const handleImageInputChange = (e, pageNo) => {
        setCurrentPageNumber(pageNo);
        const file = e.target.files[0];
        if (file && WhiltelistedFileTypes.WhiltelistedFileTypes(file.type)) {
            setErrorMsg(false);
            setShowLoader(true);
            setFileTypeErr(false);
            const reader = new FileReader();
            setPodPages([...podPages, file]);
            reader.readAsDataURL(file);
        } else {
            setFileTypeErr(true);
        }
    };

    return {
        po,
        items,
        showLoader,
        tonnage,
        errorMsg,
        otpPage,
        otp,
        setOtp,
        showError,
        openConfirmation,
        podPages,
        imageArray,
        previewImage,
        numberOfPodPages,
        showPopUp,
        podPopUp,
        doneMsg,
        fileTypeErr,
        bo,
        errorText,
        sellerOrderDetails,
        navigateToOtpPage,
        makeValidateOtp,
        closeConfirmation,
        imageValidationPopUpCloseHandler,
        handleImageInputChange,
    };
}
